export default (element) => {
    var _a;
    const translateGroups = (_a = /translate\((?<x>\d+),(?<y>\d+)\)/.exec(element.getAttribute("transform") || "")) === null || _a === void 0 ? void 0 : _a.groups;
    const translateX = Number.parseInt((translateGroups === null || translateGroups === void 0 ? void 0 : translateGroups.x) || "0") || 0;
    const translateY = Number.parseInt((translateGroups === null || translateGroups === void 0 ? void 0 : translateGroups.y) || "0") || 0;
    return { x: translateX, y: translateY };
};
